@if (appConf.appMode !== APPLICATION_MODE.EMBEDDED) {
  <ins-header insBlockHostFrame [siteName]="headerTitle"></ins-header>
}
<div class="contentBody">

  <div class="leftSideBarContainer">
    @if (appConf.sideBarContainer) {
      <ins-side-bar-container [currentPage]="currentPage" [sceneMode]="sceneMode" [pressedMenuName]="openedPanel" insBlockHostFrame></ins-side-bar-container>
    }
  </div>
  <div class="pageContainer">
    @if (appConf.appMode === APPLICATION_MODE.EMBEDDED) {
       <div class="embeddedHeader" insBlockHostFrame>
        <div class="headerTitle" #embeddedHeaderTitle insTooltip [cfg]="{text: getTooltip(embeddedHeaderTitle, headerTitle), position: {H: 'hCenter', V:'vBottom'}, type: 'info'}">{{headerTitle}}</div>
      </div>
    }
    <div class="pageBody">
      <div class="panelContainer" [style.visibility]="appConf.sideBarContainer ? 'visible' : 'hidden'">
        <div id="leftPanel" class="panelContent" #sideBarSubMenu [class.roundLeftTopCorner]="openedPanel !== 'sidebar.search'" [class.embeddedMode]="appConf.appMode === APPLICATION_MODE.EMBEDDED"
          insResizable [minWidth]="openedPanel !== 'sidebar.search' ? '200' : '432'" [maxWidth]="'750'" (doneResize)="updateWidth($event)"
          [resizeEdges]="{right: true}" [class.opened]="openedPanel !== ''" [class.searchPanel]="openedPanel === 'sidebar.search'"
          (insClickOutside)="handleClickOutside()" [ignoreHTMLIds]="['upperButtons', 'lowerButtons']">
          <div style="width: 100%; max-width: calc(100% - 2px); overflow: hidden;">
            <ins-search-res-menu [class.panelHidden]="openedPanel !== 'sidebar.search'" (closePanel)="closePanel()" [sceneMode]="sceneMode" [openedPanel]="openedPanel"></ins-search-res-menu>
            <ins-sites-menu [class.panelHidden]="openedPanel !== 'sidebar.sites'" (closePanel)="closePanel()"></ins-sites-menu>
            <ins-zones-menu [class.panelHidden]="openedPanel !== 'sidebar.zones'" (closePanel)="closePanel()"></ins-zones-menu>
            <ins-layers-menu [class.panelHidden]="openedPanel !== 'sidebar.layers'" (closePanel)="closePanel()"></ins-layers-menu>
            <ins-viewpoints-menu [class.panelHidden]="openedPanel !== 'sidebar.viewpoints'" (closePanel)="closePanel()"></ins-viewpoints-menu>
            <ins-discussion-menu [class.panelHidden]="openedPanel !== 'sidebar.discussion'" (closePanel)="closePanel()"></ins-discussion-menu>

            <ins-tour-placemark-menu [class.panelHidden]="openedPanel !== 'sidebar.tour.placemarks'" (closePanel)="closePanel()"></ins-tour-placemark-menu>

            <ins-admin-panel [class.panelHidden]="openedPanel !== 'panels.admin'" (closePanel)="closePanel()"></ins-admin-panel>
            <ins-help-panel [class.panelHidden]="openedPanel !== 'panels.help'" (closePanel)="closePanel()"> </ins-help-panel>
            <ins-settings-panel [class.panelHidden]="openedPanel !== 'panels.settings'" (closePanel)="closePanel()"></ins-settings-panel>
            <ins-profile-panel [class.panelHidden]="openedPanel !== 'panels.profile'" (closePanel)="closePanel()" [user]="currentUser"></ins-profile-panel>
          </div>
          <div class="resizeBar"></div>
        </div>
      </div>
      <div class="mainContentContainer">
        <div id="dialog-container"></div>
        <div class="sceneContainer">
          <div class="loadingLineIndicator">
            <ins-loading-line></ins-loading-line>
          </div>
          <router-outlet></router-outlet>
          <div class="sceneFooter" [style.margin-left.px]="openedPanel ? sidebarMenuWidth : 0">
            <ins-status-container></ins-status-container>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="rightSideBorder"></div>

</div>
